import type { ReceiptTemplate } from '../schema';

export const goatTemplate: ReceiptTemplate = {
  id: 'goat',
  name: 'GOAT Receipt',
  brand: 'GOAT',
  description: 'Sneaker marketplace receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'goat-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/goat.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'Order Receipt',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'goat-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Order #: GOAT-8472910\nDate: January 4, 2026',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'goat-verified',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'GOAT VERIFIED AUTHENTIC',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'goat-item',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Nike Dunk Low Panda\nBlack/White\nSize: US 9.5\nCondition: New',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'goat-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 45,
        labelAlignment: 'left',
        lines: [
          { id: 'goat-price', label: 'Item Price', value: '115.00', isBold: false, isLarge: false },
          { id: 'goat-shipping', label: 'Shipping', value: '12.00', isBold: false, isLarge: false },
          { id: 'goat-tax', label: 'Tax', value: '11.27', isBold: false, isLarge: false },
          { id: 'goat-total', label: 'Total', value: '138.27', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'goat-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Payment:\nApple Pay (Visa ****4144)',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'goat-ship',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Shipping To:\nMike Wazowski\n1200 Dark Avenue\nMonsterville, CA 94608',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'goat-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Support: goat.com/help\nAll sales are final.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

